import React from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../../index";
import { notify } from "../../Notify/Notify";
import ReactTooltip from "react-tooltip";

import "./CalendarSidebar.scss";
import viewIcon from "../../../assets/view.svg";
import redirectIcon from "../../../assets/redirect.svg";
import closeIcon from "../../../assets/close.svg";
import { withRouter } from "react-router-dom";
import DocumentView from "../../DocumentView/DocumentView";

export default withRouter(
  class CalendarSidebar extends React.Component {
    state = {
      documentId: this.props.documentId,
      documentPath: "",
      documentFile: "",
      showDocumentDetailModal: false,
      documentDetailModalInfo: {},
    };

    componentDidUpdate(prevProps) {
      if (this.props.documentId !== prevProps.documentId) {
        this.setState({ documentId: this.props.documentId });
      }
    }

    getDocument = (isView) => {
      const variables = {
        documentId: this.state.documentId,
      };

      apolloClient
        .query({
          query: gql`
            query document($documentId: UUID!) {
              document(documentId: $documentId) {
                id
                title
                fileUrl
                isArchive
                folder {
                  id
                  parentFolder {
                    id
                  }
                }
                documentType {
                  id
                  title
                }
                status {
                  id
                  name
                }
                modifiedBy {
                  email
                  firstName
                  lastName
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                createdBy {
                  email
                  firstName
                  lastName
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                modifiedTs
                abstractJson
                sharedDocument {
                  id
                  user {
                    id
                    email
                    username
                    firstName
                    lastName
                    profile {
                      image
                      role {
                        id
                        name
                      }
                    }
                  }
                  userRole {
                    id
                    name
                  }
                }
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          let document = result.data.document[0];
          let documentFile = document.fileUrl;
          let documentPath = document.isArchive
            ? `/archives/${document.folder.parentFolder.id}/${document.folder.id}`
            : `/files/${document.folder.parentFolder.id}/${document.folder.id}`;

          !isView && this.props.history.push(documentPath);
          this.setState({ documentFile, documentPath });
          if (isView) {
            const doc = { ...document };
            doc.abstractJson = JSON.parse(doc.abstractJson);
            this.setState({
              showDocumentDetailModal: true,
              documentDetailModalInfo: {
                title: document.title,
                fileUrl: document.fileUrl,
                documentObj: doc,
                viewOnly: true,
              },
            });
          }
        })
        .catch((e) => {
          this.setState({ isLoading: false });
          const title = "Error";
          const detail = e.message;
          const type = "error";
          notify(title, detail, type);
        });
    };

    getDocumentFields = () => {
      return this.props.documentFields.map((field, index) => (
        <div className="document-row" key={index}>
          <p className="col-6 title">{field.key}</p>
          <p className="col-6 value">
            {field.value.length > 0 ? field.value : "-"}
          </p>
        </div>
      ));
    };

    render() {
      return (
        <>
          <div className="calendar-sidebar">
            <div className="calendar-sidebar-header">
              <div className="header-title-holder">
                <div
                  className="event-dot"
                  style={{
                    backgroundColor: `${this.props.extendedProps.color}`,
                  }}
                ></div>
                <span className="event-title calender-sidebar-title">
                  {this.props.title}
                </span>
              </div>
              <ReactTooltip id="docViewTip" place="top" effect="solid">
                Preview document
              </ReactTooltip>
              <ReactTooltip id="redirectTip" place="top" effect="solid">
                Return to file location
              </ReactTooltip>
              <div className="header-icons-holder">
                <img
                  src={viewIcon}
                  alt="view"
                  onClick={() => this.getDocument(true)}
                  data-tip data-for="docViewTip"
                />
                <img
                  src={redirectIcon}
                  alt="redirect"
                  onClick={() => this.getDocument(false)}
                  data-tip data-for="redirectTip"
                />
                <img
                  src={closeIcon}
                  alt="close"
                  onClick={this.props.closeSidebar}
                />
              </div>
            </div>
            <div className="calendar-sidebar-body">
              <div className="description">{this.props.description}</div>
              <div className="document-fields">{this.getDocumentFields()}</div>
            </div>
          </div>

          <DocumentView
            calendarView={true}
            showModal={this.state.showDocumentDetailModal}
            handleClose={(shouldReLoadData = false) => {
              this.setState({ showDocumentDetailModal: false });
            }}
            {...this.state.documentDetailModalInfo}
            userRoleId={this.props.userRoleId}
            currentUserInfo={this.props.currentUserInfo}
          />
        </>
      );
    }
  }
);
